import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Expense } from "./expense";
import { Props } from "./types";
import styles from "./styles.scss";

function compareDates(dateA: Date, dateB: Date) {
  if (dateA > dateB) return 1;
  if (dateA < dateB) return -1;
  return 0;
}

function ExpensesTable({ project, projectExpenses }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.projectExpenses}>
      <div className={styles.header}>
        <div className={classNames(styles.cell, styles.bigCell)}>
          {t("projectBudgetSynthesis.expenses.orderNumber")}
        </div>
        <div className={classNames(styles.cell, styles.bigCell)}>
          {t("projectBudgetSynthesis.expenses.name")}
        </div>
        <div className={classNames(styles.cell, styles.bigCell)}>
          {t("projectBudgetSynthesis.expenses.expenseType")}
        </div>
        <div className={classNames(styles.cell, styles.smallCell)}>
          {t("projectBudgetSynthesis.expenses.quantity")}
        </div>
        <div className={classNames(styles.cell, styles.smallCell)}>
          {t("projectBudgetSynthesis.expenses.unitAmount")}
        </div>
        <div className={classNames(styles.cell, styles.smallCell)}>
          {t("projectBudgetSynthesis.expenses.totalAmount")}
        </div>
        <div className={classNames(styles.cell, styles.mediumCell)}>
          {t("projectBudgetSynthesis.expenses.attachments")}
        </div>
        <div className={classNames(styles.cell, styles.mediumCell)}>
          {t("projectBudgetSynthesis.expenses.plannedDate")}
        </div>
        <div className={classNames(styles.cell, styles.mediumCell)}>
          {t("projectBudgetSynthesis.expenses.actualDate")}
        </div>
        <div className={classNames(styles.cell, styles.smallCell)} />
      </div>
      {[...projectExpenses]
        .sort((a, b) =>
          compareDates(new Date(a.createdDate), new Date(b.createdDate)),
        )
        .map((projectExpense) => (
          <Expense
            key={projectExpense.uuid}
            projectExpense={projectExpense}
            project={project}
          />
        ))}
    </div>
  );
}

export { ExpensesTable };
